import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-verify-fail',
  templateUrl: './email-verify-fail.component.html',
  styleUrls: ['./email-verify-fail.component.scss']
})
export class EmailVerifyFailComponent implements OnInit {

  constructor(private _dialogRef: MatDialogRef<EmailVerifyFailComponent>,) { }

  ngOnInit(): void {
  }

  dialogClose(){
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }

}
